import moment from 'moment';
import { cloneCustomerServiceFormData } from './customerServiceFormStateHelpers';

export const normalizeAllocationConfiguration = (item = {}, allocationRoleKeys = [], now = moment()) => {
    const isCurrentActive = (row) => row?.status === 'ACTIVE'
        && (!row.effective_from || moment(row.effective_from).isSameOrBefore(now))
        && (!row.effective_to || moment(row.effective_to).isAfter(now));
    // Dữ liệu người dùng vừa thao tác chưa có id/status/version cho đến khi backend lưu.
    const isUnsaved = (row) => !row?.id && !row?.status;
    const activeAllocationModes = (item.allocation_modes || [])
        .filter((row) => isUnsaved(row) || isCurrentActive(row))
        .sort((left, right) => Number(right.version || 0) - Number(left.version || 0))
        .filter((row, idx, rows) => rows.findIndex((candidate) => candidate.role_key === row.role_key) === idx);
    const activeVersions = new Map(activeAllocationModes.map((row) => [row.role_key, Number(row.version || 0)]));
    const belongsToActiveVersion = (row) => isUnsaved(row) || (
        isCurrentActive(row) && activeVersions.get(row.role_key) === Number(row.version || 0)
    );

    return {
        allocation_modes: activeAllocationModes.length
            ? activeAllocationModes.map((row) => ({ ...row }))
            : allocationRoleKeys.map((roleKey) => ({ role_key: roleKey, allocation_mode: 'equal_split', is_manual_override: false })),
        allocation_agreements: Array.isArray(item.allocation_agreements)
            ? item.allocation_agreements.filter(belongsToActiveVersion).map(cloneCustomerServiceFormData)
            : [],
        work_units: Array.isArray(item.work_units)
            ? item.work_units.filter(belongsToActiveVersion).map((row) => ({
                id: row.id,
                employee_id: Number(row.employee_id),
                role_key: row.role_key,
                unit_type: row.unit_type || 'session',
                unit_value: Number(row.unit_value) || 0,
                revenue_scope: row.revenue_scope || 'private',
                note: row.note || '',
            }))
            : [],
    };
};
